import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55846286"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-content" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "content" }

import SettingsDetails from "@/components/settings/SettingsDetails/SettingsDetails.vue";
import Form from "@/components/layouts/Form.vue";
import GenericButton from "@/components/buttons/GenericButton.vue";
import { ActionTypes } from "@/store";
import { GenericButtonVariantEnum } from "@/types/button";
import {
  FormFieldNameEnum,
  FormFieldType,
  FormType,
  RegisterFormDataObjectType,
} from "@/types/form";
import {
  getInitialFormData,
  getIsFormValid,
  registerFormFields,
} from "@/utils/form";
import { reactive } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Input from "../forms/Input.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsActivateAccount',
  setup(__props) {

const data = reactive(
  getInitialFormData<RegisterFormDataObjectType>(registerFormFields),
);
const { dispatch } = useStore();
const router = useRouter();

// adjust submit handler
const handleSubmit = async () => {
  const { errors, ...fields } = data;

  const isFormValid = getIsFormValid(
    data,
    registerFormFields,
    FormType.Register,
  );
  if (!isFormValid) {
    return;
  }

  try {
    await dispatch(ActionTypes.UPDATE_USER, {
      name: data.name,
      email: data.email,
      password: data.password,
    });
    data.errors = fields;
    router.replace("/settings");
  } catch (error) {
    dispatch(ActionTypes.MOUNT_SNACKBAR, {
      title: "snackbar.errors.wrongCredentials.title",
      text: "snackbar.errors.wrongCredentials.text",
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SettingsDetails, {
    title: _ctx.$t('settings.activateAccountContent.activationOfAccount')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Form, { onSubmitForm: handleSubmit }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(Input, {
                  modelValue: data.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.name) = $event)),
                  name: _unref(FormFieldNameEnum).Name,
                  label: "settings.personalDetailsContent.fullName",
                  placeholder: "auth.name",
                  required: "",
                  errors: data.errors
                }, null, 8, ["modelValue", "name", "errors"]),
                _createVNode(Input, {
                  modelValue: data.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.email) = $event)),
                  name: _unref(FormFieldNameEnum).Email,
                  label: "auth.email",
                  placeholder: "auth.email",
                  required: "",
                  errors: data.errors
                }, null, 8, ["modelValue", "name", "errors"]),
                _createVNode(Input, {
                  modelValue: data.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.password) = $event)),
                  name: _unref(FormFieldNameEnum).Password,
                  type: _unref(FormFieldType).Password,
                  label: "auth.password",
                  placeholder: "auth.password",
                  required: "",
                  errors: data.errors
                }, null, 8, ["modelValue", "name", "type", "errors"])
              ]),
              _createVNode(GenericButton, {
                variant: _unref(GenericButtonVariantEnum).Primary,
                text: "settings.activateAccount"
              }, null, 8, ["variant"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})